<template>
	<div id="estadisticas" class="tab-content">
		<clip-loader class="dashboard-tab-loader" :loading="isCargandoEvento" :color="'var(--color-blue-link)'" :size="'52px'"></clip-loader>
		<div class="tab-main" v-if="!isCargandoEvento && Evento">
			<div class="column">
				<div class="card-asistencia asistencia-total">
					<div class="asistencia-left">
						<span class="cant-tickets">{{ Evento.Numeros.CantidadTickets }} <span class="cant-capacidad">/ {{ Evento.Numeros.Capacidad }}</span></span>
						<span class="label">Asistencia</span>
					</div>
					<div class="porcentaje-asistencia">
						<div class="percent">
							<svg>
								<circle cx="34" cy="34" r="34"></circle>
								<circle cx="34" cy="34" r="34" :style="{ 'stroke-dashoffset': 213 - (213 * Evento.Numeros.Porcentaje) / 100 }"></circle>
							</svg>
							<div class="number">
								<h2>{{ Math.round((parseFloat(Evento.Numeros.Porcentaje) + Number.EPSILON) * 100) / 100 }}<span>%</span></h2>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="column">
				<div class="card-asistencia asistencia-escaneo">
					<div class="asistencia-left">
						<span class="cant-tickets">{{ Evento.Numeros.CantidadEscaneadas }}</span>
						<span class="label">Escaneadas</span>
					</div>
					<div class="porcentaje-asistencia">
						<div class="percent">
							<svg>
								<circle cx="34" cy="34" r="34"></circle>
								<circle cx="34" cy="34" r="34" :style="{ 'stroke-dashoffset': 213 - (213 * Evento.Numeros.PorcentajeEscaneadas) / 100 }"></circle>
							</svg>
							<div class="number">
								<h2>{{ Math.round((parseFloat(Evento.Numeros.PorcentajeEscaneadas) + Number.EPSILON) * 100) / 100 }}<span>%</span></h2>
							</div>
						</div>
					</div>
					<i class='bx bx-qr-scan' style="position: absolute; top: 20px; right: 20px; font-size: 32px;color: var(--color-grey);"></i>
				</div>
			</div>
			<div class="column">
				<div class="evento-nombre-competencia">
					<div class="evento-nombre">
						{{ Evento.EventoNombre }}
					</div>
					<div class="competencia-nombre">
						{{ Evento.CompetenciaNombre }}
					</div>
					<div class="competencia-nombre">
						{{ Evento.CompetenciaInstanciaNombre }}
					</div>
				</div>
			</div>
			<div class="column">

			</div>
			<div class="column" v-if="orAc.Permisos.includes('VerAsistenciaPorTipo')">
				<div class="card">
					<div class="card-title">
						Asistencia por tipo de ticket
						<div class="actualizar" @click="actualizar()">
							<i class='bx bx-refresh' ></i>
						</div>
					</div>
					<div class="card-main">
						<div class="card-row">
							<div class="card-row-dato">
								<i class='bx bx-transfer'></i>
								<span class="cant-tickets">{{ Evento.Numeros.CantidadCanjes }} <span class="cant-capacidad">({{ Evento.Numeros.PorcentajeCanjes }}%)</span></span>
								<span class="label">Canjes</span>
							</div>
							<div class="card-row-dato">
								<i class='bx bxs-discount' ></i>
								<span class="cant-tickets">{{ Evento.Numeros.CantidadInvitaciones }} <span class="cant-capacidad">({{ Evento.Numeros.PorcentajeInvitaciones }}%)</span></span>
								<span class="label">Invitaciones</span>
							</div>
							<div class="card-row-dato">
								<i class='bx bx-money' ></i>
								<span class="cant-tickets">{{ Evento.Numeros.CantidadVentas }} <span class="cant-capacidad">({{ Evento.Numeros.PorcentajeVentas }}%)</span></span>
								<span class="label">Ventas</span>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="column" v-else></div>
			<div class="column w-75" style="grid-column: 2/5;" v-if="orAc.Permisos.includes('VerRecaudacion')">
				<div class="card">
					<div class="card-title">
						Recaudación
						<div class="actualizar" @click="actualizar()">
							<i class='bx bx-refresh' ></i>
						</div>
					</div>
					<div class="card-main">
						<div class="flow-recaudacion">
							<div class="group group-big group-left">
								<div class="group-info">
									<span class="monto">{{ Evento.MonedaSimbolo }} {{ Evento.Numeros.Recaudacion.RecaudacionTotal.replace('.00', '') }}</span>
									<span class="label">Total recaudado</span>
								</div>
								<img src="../../assets/bracket.svg" class="main-bracket">
							</div>
							<div class="flow-main">
								<div class="flow-row">
									<div class="group group-big">
										<img src="https://cnf-s3-bucket.s3.us-east-1.amazonaws.com/mp.svg" class="medio-pago">
										<div class="group-info">
											<span class="monto">{{ Evento.MonedaSimbolo }} {{ Evento.Numeros.Recaudacion.RecaudacionMercadoPago.replace('.00', '') }} <!--<span class="porcentaje">(60%)</span>--></span>
											<span class="label">Total vía MercadoPago</span>
										</div>
									</div>
									<div class="group">
										<div class="organizador" :style="{ 'background-color': '#' + Evento.OrganizadorBackgroundColor}">
											<img :src="Evento.OrganizadorLogo" :alt="Evento.OrganizadorNombre">
										</div>
										<div class="group-info">
											<span class="monto">{{ Evento.MonedaSimbolo }} {{ Evento.Numeros.Recaudacion.RecaudacionOrganizadorMP.replace('.00', '') }} <!--<span class="porcentaje">(60%)</span>--></span>
											<span class="label">Organizador</span>
										</div>
									</div>
									<div class="group">
										<img src="https://cnf-s3-bucket.s3.us-east-1.amazonaws.com/mp.svg" class="medio-pago">
										<div class="group-info">
											<span class="monto">{{ Evento.MonedaSimbolo }} {{ Evento.Numeros.Recaudacion.RecaudacionComisionMP.replace('.00', '') }} <!--<span class="porcentaje">(60%)</span>--></span>
											<span class="label">Comisión MercadoPago</span>
										</div>
									</div>
									<div class="group">
										<div class="lineup">
											<img src="../../assets/logos/mate/lineup-black.svg" alt="LineUp Tickets">
										</div>
										<div class="group-info">
											<span class="monto">{{ Evento.MonedaSimbolo }} {{ Evento.Numeros.Recaudacion.RecaudacionLineUpMP.replace('.00', '') }} <!--<span class="porcentaje">(60%)</span>--></span>
											<span class="label">LineUp Tickets</span>
										</div>
									</div>
								</div>
								<div class="flow-row flow-row-center">
									<div class="group group-unstyled">
										
									</div>
									<div class="group group-centered">
										<div class="total-wrapper">
											<span class="total-label">Total organizador</span>
											<span class="total-centered">{{ Evento.MonedaSimbolo }} {{ Evento.Numeros.Recaudacion.RecaudacionOrganizador.replace('.00', '') }}</span>
										</div>
									</div>
									<div class="group group-centered">
										<div class="total-wrapper">
											<span class="total-label">Total comisiones</span>
											<span class="total-centered">{{ Evento.MonedaSimbolo }} {{ Evento.Numeros.Recaudacion.RecaudacionComisionesMediosPago.replace('.00', '') }}</span>
										</div>
									</div>
									<div class="group group-centered">
										<div class="total-wrapper">
											<span class="total-label">Total LineUp</span>
											<span class="total-centered">{{ Evento.MonedaSimbolo }} {{ Evento.Numeros.Recaudacion.RecaudacionLineUp.replace('.00', '') }}</span>
										</div>
									</div>
								</div>
								<div class="flow-row">
									<div class="group group-big">
										<img src="https://cnf-s3-bucket.s3.us-east-1.amazonaws.com/rp.png" class="medio-pago">
										<div class="group-info">
											<span class="monto">{{ Evento.MonedaSimbolo }} {{ Evento.Numeros.Recaudacion.RecaudacionRedPagos.replace('.00', '') }} <!--<span class="porcentaje">(40%)</span>--></span>
											<span class="label">Total vía RedPagos</span>
										</div>
									</div>
									<div class="group">
										<div class="organizador" :style="{ 'background-color': '#' + Evento.OrganizadorBackgroundColor}">
											<img :src="Evento.OrganizadorLogo" :alt="Evento.OrganizadorNombre">
										</div>
										<div class="group-info">
											<span class="monto">{{ Evento.MonedaSimbolo }} {{ Evento.Numeros.Recaudacion.RecaudacionOrganizadorRP.replace('.00', '') }} <!--<span class="porcentaje">(60%)</span>--></span>
											<span class="label">Organizador</span>
										</div>
									</div>
									<div class="group">
										<img src="https://cnf-s3-bucket.s3.us-east-1.amazonaws.com/rp.png" class="medio-pago">
										<div class="group-info">
											<span class="monto">{{ Evento.MonedaSimbolo }} {{ Evento.Numeros.Recaudacion.RecaudacionComisionRP.replace('.00', '') }} <!--<span class="porcentaje">(60%)</span>--></span>
											<span class="label">Comisión RedPagos</span>
										</div>
									</div>
									<div class="group">
										<div class="lineup">
											<img src="../../assets/logos/mate/lineup-black.svg" alt="LineUp Tickets">
										</div>
										<div class="group-info">
											<span class="monto">{{ Evento.MonedaSimbolo }} {{ Evento.Numeros.Recaudacion.RecaudacionLineUpRP.replace('.00', '') }} <!--<span class="porcentaje">(60%)</span>--></span>
											<span class="label">LineUp Tickets</span>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="column w-75" v-else></div>
			<div class="column w-75" v-if="orAc.Permisos.includes('VerDesgloseAcceso')">
				<div class="card">
					<div class="card-title">
						Desglose detallado por acceso
						<div class="actualizar" @click="actualizar()">
							<i class='bx bx-refresh' ></i>
						</div>
					</div>
					<div class="card-main card-main-start">
						<div class="tb">
							<div class="tb-header">
								<div style="width: 26%;" class="tb-header-th">Acceso</div>
								<div style="width: 9%; justify-content: center;" class="tb-header-th">Capacidad</div>
								<div style="width: 9%; justify-content: center;" class="tb-header-th">Disp.</div>
								<div style="width: 9%; justify-content: center;" class="tb-header-th">Asistencia</div>
								<div style="width: 10%; justify-content: center;" class="tb-header-th">Porcentaje</div>
								<div style="width: 9%; justify-content: center;" class="tb-header-th">Canjes</div>
								<div style="width: 9%; justify-content: center;" class="tb-header-th">Invitaciones</div>
								<div style="width: 9%; justify-content: center;" class="tb-header-th">Ventas</div>
								<div style="width: 10%; justify-content: center;" class="tb-header-th">Recaudación</div>
							</div>
							<div class="tb-body">
								<div class="tb-body-row" v-for="acceso in desgloseAccesos" :key="acceso.SectorCod">
									<div style="width: 26%;" class="tb-body-td tb-body-td-sector">
										<span class="tribuna" v-if="acceso.TribunaNombre.toUpperCase().trim() !== acceso.SectorDescripcion.toUpperCase().trim()">
											{{ acceso.TribunaNombre }}
										</span>
										<span class="sector">
											{{ acceso.SectorDescripcion }}
										</span>
									</div>
									<div style="width: 9%; text-align: center; font-weight: 700;" class="tb-body-td">{{ acceso.SectorAforo }}</div>
									<div style="width: 9%; text-align: center; font-weight: 700;" class="tb-body-td">{{ acceso.SectorDisponibilidad }}</div>
									<div style="width: 9%; text-align: center; font-weight: 700;" class="tb-body-td">{{ acceso.SectorAsistencia }}</div>
									<div style="width: 10%; text-align: center; font-weight: 700;" class="tb-body-td">
										<div class="porcentaje-acceso" :style="'width: ' + acceso.SectorPorcentaje + '%;'" :class="acceso.SectorPorcentaje > 50 && acceso.SectorPorcentaje < 85 ? 'porcentaje-naranja' : acceso.SectorPorcentaje >= 85 ? 'porcentaje-rojo': ''"></div>
										{{ acceso.SectorAsistenciaPorcentaje }}
									</div>
									<div style="width: 9%; text-align: center;" class="tb-body-td">{{ acceso.SectorSocios }}</div>
									<div style="width: 9%; text-align: center;" class="tb-body-td">{{ acceso.SectorInvitaciones }}</div>
									<div style="width: 9%; text-align: center;" class="tb-body-td">{{ acceso.SectorVentas }}</div>
									<div style="width: 10%; text-align: center;" class="tb-body-td">{{ acceso.SectorRecaudado }}</div>
								</div>
								<div class="tb-body-row no-results" v-if="desgloseAccesos.length <= 0">
									<span>Actualiza la información para ver el desglose</span>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="column w-75" v-else></div>
			<div class="column" v-if="orAc.Permisos.includes('VerDesgloseAcceso')">
				<div class="card">
					<div class="card-title">
						Asistencia por acceso
						<div class="actualizar" @click="actualizar()">
							<i class='bx bx-refresh' ></i>
						</div>
					</div>
					<div class="card-main">
						<fusioncharts
							type="doughnut2d"
							width="100%"
							height="340"
							dataFormat="json"
							:dataSource="dataDesgloseSector"
							ref="fc"
							v-if="!isCargandoEvento"
						></fusioncharts>
					</div>
				</div>
			</div>
			<div class="column" v-else></div>
		</div>
	</div>
</template>

<script>
	import axios from 'axios'
	import { mapState, mapActions, mapGetters }  from 'vuex';
	import ClipLoader from 'vue-spinner/src/ClipLoader.vue'

	export default {
		data(){
			return{
				isCargandoEvento: true,
				Evento: null,
				EventoId: Number(this.$route.params.eventoId),

				// Desglose de accesos
				desgloseAccesos: [],
				dataDesgloseSector: {
					chart: {
						"showValues":"1",
						"showPercentInTooltip" : "0",
						"numberPrefix" : "",
						"enableMultiSlicing":"1",
						"theme": "fusion"
					},
					data: []
				},
			}
		},
		components: {
			ClipLoader
		},
		computed: {
			...mapState('AuthModule', ['user', 'organizadorActivo']),
			...mapGetters('AuthModule', ['orAc']),
		},
		async mounted(){
			this.isCargandoEvento = true;
			await this.getEstadisticas();
			await this.getDesgloseAccesos();
			this.isCargandoEvento = false;
		},
		methods: {
			...mapActions('AuthModule', ['logout']),

			async getEstadisticas(){
				try {
					let response = await axios.post('/WSOrgEveEstadisticas', {
						OrganizadorId: Number(this.organizadorActivo),
						UsuarioId : this.user.UsuarioId,
						EventoId: this.EventoId
					}, { headers: {"Authorization" : `Bearer ${ this.user.AccessToken }`} });

					if(response.data.ErrorCod === 1){
						this.logout();
					} else {
						if(response.data.ErrorCod === 10 || response.data.ErrorCod === 11){
							this.$store.dispatch('showError', 'Necesitas permisos para ver esta sección.')
							this.$router.push({ name: 'home' });
						} else {
							this.Evento = response.data.SDTDashboardEvento
						}
					}
				} catch (error) {
					this.$store.dispatch('showError', 'Ocurrió un error, intente nuevamente.')
					this.$router.push({ name: 'error' })
				}
			},
			async actualizar(){
				this.isCargandoEvento = true;
				this.desgloseAccesos = []
				await this.getEstadisticas();
				await this.getDesgloseAccesos();
				this.isCargandoEvento = false;
			},
			async getDesgloseAccesos(){
				try {
					let response = await axios.post('/WSOrgEveDesgloseAccesos', {
						OrganizadorId: Number(this.organizadorActivo),
						UsuarioId : this.user.UsuarioId,
						EventoId: this.EventoId
					}, { headers: {"Authorization" : `Bearer ${ this.user.AccessToken }`} });

					if(response.data.ErrorCod === 1){
						this.logout();
					} else {
						if(response.data.ErrorCod === 10 || response.data.ErrorCod === 11){
							this.$store.dispatch('showError', 'Necesitas permisos para ver esta sección.')
							this.$router.push({ name: 'home' });
						} else {
							this.desgloseAccesos = response.data.SDTDashboardSectoresEstadisticas

							let porc = 0
							let asis = 0
							let sect = {}
							this.dataDesgloseSector.data = []
							this.desgloseAccesos.forEach((t,index) => {
								porc = parseFloat(t.SectorAsistenciaPorcentaje.substring(0, t.SectorAsistenciaPorcentaje.length - 1))
								this.desgloseAccesos[index].SectorPorcentaje = porc
								asis = parseInt(t.SectorAsistencia)

								if(asis > 0){
									sect = {
										label: t.SectorDescripcion,
										value: asis
									}
		
									this.dataDesgloseSector.data.push(sect)
								}
							});
						}
					}
				} catch (error) {
					this.$store.dispatch('showError', 'Ocurrió un error, intente nuevamente.')
					this.$router.push({ name: 'error' })
				}
			}
		}
	}
</script>

<style lang="scss">
	.fusioncharts-container{
		& > svg{
			& > g:nth-of-type(2n){
				display: none !important;
			}
		}
	}
</style>